import { readQuantity } from 'support/helpers/packingList/packableQuantity';

import { placedKey } from '../helpers/placedKey';
import { LineItemEntry, LineItemId, TransportUnitId, TransportUnitNode } from '../types';

export const getProducts = (
  lineItems: Record<LineItemId, LineItemEntry>,
  quantityFieldPath: string,
): Array<LineItemEntry> =>
  Object.values(lineItems)
    // Sub-items ride along their parent; items with no quantity at all can't be placed, so
    // they never enter the packing list.
    .filter((entry) => !entry.row._internal?.parent_line_item && readQuantity(entry.row[quantityFieldPath]) > 0)
    .sort((a, b) => a.originalIndex - b.originalIndex);

export const getRemainingByLineItem = (
  products: Array<LineItemEntry>,
  placedByLineItem: Map<LineItemId, number>,
  quantityFieldPath: string,
): Map<LineItemId, number> => {
  const remaining = new Map<LineItemId, number>();
  for (const entry of products) {
    const lineTotal = readQuantity(entry.row[quantityFieldPath]);
    remaining.set(entry.id, lineTotal - (placedByLineItem.get(entry.id) ?? 0));
  }
  return remaining;
};

export const getPlacedContentByKey = (
  transportUnits: Array<TransportUnitNode>,
): Map<string, { tuId: TransportUnitId; lineItemId: LineItemId; quantity: number }> => {
  const map = new Map<string, { tuId: TransportUnitId; lineItemId: LineItemId; quantity: number }>();
  const walk = (nodes: Array<TransportUnitNode>) => {
    for (const node of nodes) {
      for (const content of node.contents) {
        map.set(placedKey(node.id, content.lineItemId), {
          tuId: node.id,
          lineItemId: content.lineItemId,
          quantity: content.quantity,
        });
      }
      walk(node.children);
    }
  };
  walk(transportUnits);
  return map;
};
